<template>
  <v-form ref="formularioAperturaManual">
    <v-dialog v-model="visible" scrollable max-width="500">
      <v-card elevation="4">
        <v-card-title style="background-color: #90D0F0;">
          <v-icon class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">mdi-boom-gate-arrow-up</v-icon>
          {{ $t ('Apertura manual de barrera') }}
        </v-card-title>
        <v-card-text>
          <div style="height: 20px"></div>

          <v-container v-if="hayProductoAsociado" fluid>

            <v-row justify="center">
              <v-col cols="8">
                <v-text-field
                  label="Aparato"
                  prepend-inner-icon="mdi-boom-gate"
                  dense
                  hide-details
                  readonly
                  :value="descripcionAparato"
                ></v-text-field>

                <v-text-field
                  label="Grupo de productos"
                  class="mt-6"
                  prepend-inner-icon="mdi-package-variant"
                  dense
                  hide-details
                  readonly
                  :value="descripcionGrupoProductos"
                ></v-text-field>

                <v-text-field
                  label="Numero de producto"
                  class="mt-6"
                  prepend-inner-icon="mdi-counter"
                  dense
                  hide-details
                  readonly
                  :value="numeroProducto"
                ></v-text-field>

                <v-text-field
                  label="Titular del producto"
                  class="mt-6"
                  prepend-inner-icon="mdi-badge-account-horizontal-outline"
                  dense
                  hide-details
                  readonly
                  :value="titular"
                ></v-text-field>

                <v-text-field
                  label="Matrícula último movimiento"
                  class="mt-6"
                  prepend-inner-icon="mdi-car"
                  dense
                  hide-details
                  readonly
                  :value="matriculaUltimoMovimiento"
                ></v-text-field>

                <v-text-field
                  v-if="textoTiempoImporte"
                  label="Tiempo / Importe"
                  class="mt-6"
                  prepend-inner-icon="mdi-cash-multiple"
                  dense
                  hide-details
                  readonly
                  :value="textoTiempoImporte"
                ></v-text-field>

              </v-col>
            </v-row>

            <div style="height: 20px"></div>
          </v-container>

          <!-- -------------------------- -->

          <v-select
            label="Motivo"
            class="mt-4"
            prepend-inner-icon="mdi-information-variant"
            dense
            :items="listaMotivos"
            v-model="motivo"
            :error-messages="mensajesErrorMotivo"
          ></v-select>

          <v-text-field
            label="Matrícula"
            class="mt-4"
            prepend-inner-icon="mdi-car"
            dense
            hide-details
            v-model="matricula"
            v-inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Za-z]', 'g'], longitudMaxima: 12 }"
          ></v-text-field>

          <v-textarea
            ref="campoObservaciones"
            label="Observaciones"
            class="mt-3"
            v-model="observaciones"
            prepend-inner-icon="mdi-message-question-outline"
            :rules="[habilitarBotonAbrir || 'Debe indicar el motivo de la apertura']"
            :rows="2"
            auto-grow
            @keypress="keypressCampoObservaciones"
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions class="mt-n4">
          <v-spacer />
          <v-btn v-if="!hayProductoAsociado" text color="green darken-2" @click="aceptarDialogo" :disabled="!habilitarBotonAbrir">{{ $t ('Abrir') }}</v-btn>
          <v-btn v-if="hayProductoAsociado" text color="green darken-2" @click="aceptarDialogo" :disabled="!habilitarBotonAbrir">{{ $t ('Abrir y corregir estado') }}</v-btn>
          <v-btn text color="black lighten-2" @click="cancelarDialogo">{{ $t ('Cancelar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import CONSTANTES_SAGA from "@/constantesSAGA"

export default {
  props: {

  },
  data() {
    this.promesaResolve = null;
    this.promesaReject = null;
    this.botonAceptarClicado = false;
    return {
      visible: false,
      datosContextoAperturaManual: null,
      descripcionAparato: null,
      descripcionGrupoProductos: null,
      numeroProducto: null,
      titular: null,
      matriculaUltimoMovimiento: null,
      textoTiempoImporte: null,
      matricula: null,
      motivo: null,
      observaciones: '',
      listaMotivos: [],
    }
  },
  watch: {
    visible () {
      if (!this.visible) {
        if (this.botonAceptarClicado)
          this.promesaResolve ({
                                 ini_datos_soporte: this.datosContextoAperturaManual.ini_datos_soporte,
                                 ini_incidencia_relacionada: this.datosContextoAperturaManual.ini_incidencia_relacionada,
                                 resultado_autorizacion: this.datosContextoAperturaManual.resultado_autorizacion,
                                 matricula: this.matricula,
                                 codigo_motivo_apertura: this.motivo,
                                 observaciones: this.observaciones
                               });
        else
          this.promesaReject ();
      }
    }
  },
  computed: {
    mensajesErrorMotivo() {
      if (this.$parametros_configuracion.forobsapeman && !this.motivo)
        return ['Debe indicar el motivo de la apertura'];
      else
        return [];
    },
    hayProductoAsociado() {
      return this.datosContextoAperturaManual && this.datosContextoAperturaManual.json && this.datosContextoAperturaManual.json.datsop;
    },
    hayIncidenciaRelacionada() {
      return this.datosContextoAperturaManual && this.datosContextoAperturaManual.json && this.datosContextoAperturaManual.json.increl;
    },
    habilitarBotonAbrir() {
      if (!this.$parametros_configuracion.forobsapeman)
        return true;
      else
        return (this.motivo && (this.motivo != CONSTANTES_SAGA.MAM_OTRO)) || (this.observaciones.trim() != '');
    }
  },
  methods: {
    mostrar (objetoAparato,  DCAM) { // DCAM = Datos Contexto Apertura Manual
      //console.log (DCAM);
      this.datosContextoAperturaManual =  DCAM;
      this.botonAceptarClicado = false;

      this.descripcionAparato = objetoAparato.des;

      // si hay un producto asociado, cargamos sus datos
      if (this.hayProductoAsociado) {
        this.descripcionGrupoProductos = this.datosContextoAperturaManual.json.datsop ['(desgrupro)'] || '---';
        this.numeroProducto = this.datosContextoAperturaManual.json.datsop ['(numpro)'] || '---';
        this.titular = this.datosContextoAperturaManual.json.datsop ['nomtit'] || '';
        if (this.datosContextoAperturaManual.json.datsop ['mos']) {
          if (this.titular != '') this.titular += ' / ';
          this.titular += this.datosContextoAperturaManual.json.datsop ['mos'];
        }
        this.matriculaUltimoMovimiento = this.datosContextoAperturaManual.json.datsop ['matultmov'] || '---';
      } else {
        this.descripcionGrupoProductos = '---';
        this.numeroProducto = '---';
        this.titular = '---';
        this.matriculaUltimoMovimiento = '---';
      }
      this.matricula = this.datosContextoAperturaManual.matricula_reconocida;
      this.textoTiempoImporte = '';
      this.motivo = null;
      this.observaciones = '';

      // rellenamos automaticamente "el motivo" segun el resultado de la consulta de autorización
      if (this.datosContextoAperturaManual && (this.datosContextoAperturaManual.resultado_autorizacion !== undefined)) {
        switch (this.datosContextoAperturaManual.resultado_autorizacion) {
          //--- Motivos concretos:
          case CONSTANTES_SAGA.AP_VEHICULO_NO_AUTORIZADO:
            this.motivo = CONSTANTES_SAGA.MAM_VEHICULO_NO_AUTORIZADO;
            break;
          case CONSTANTES_SAGA.AP_PRODUCTO_CADUCADO:
            this.motivo = CONSTANTES_SAGA.MAM_PRODUCTO_CADUCADO;
            break;
          case CONSTANTES_SAGA.AP_PRESENCIA_INCORRECTA:
            this.motivo = CONSTANTES_SAGA.MAM_ERROR_PRESENCIA;
            break;
          case CONSTANTES_SAGA.AP_PENDIENTE_PAGO:
            this.motivo = CONSTANTES_SAGA.MAM_EXCESO_TIEMPO;
            break;
          case CONSTANTES_SAGA.AP_ENTRADA_FUERA_HORARIO:
            this.motivo = CONSTANTES_SAGA.MAM_ERROR_HORARIO;
            break;
          case CONSTANTES_SAGA.AP_MAXIMO_PRODUCTOS_PRESENTES_ALCANZADO:
            this.motivo = CONSTANTES_SAGA.MAM_MAXIMO_PLAZAS_ALCANZADO;
            break;
          default:
            if (![CONSTANTES_SAGA.AP_AUTORIZADO, CONSTANTES_SAGA.AP_AUTORIZACION_NO_DISPONIBLE].includes (this.datosContextoAperturaManual.resultado_autorizacion)) {
              this.motivo = CONSTANTES_SAGA.MAM_OTRO;
              this.observaciones = this.datosContextoAperturaManual.descripcion_resultado_autorizacion;
            }
        }
      }

      // si hay una incidencia relacionada, cargamos sus datos
      if (this.hayIncidenciaRelacionada) {
        let increl = this.datosContextoAperturaManual.json.increl;
        if (increl.codtipinc != CONSTANTES_SAGA.INC_DESCONOCIDA) {
          if (this.observaciones != '')
            this.observaciones += '. ';
          this.observaciones += this.$t ('Incidencia relacionada') + ': ' + increl.fechor + ' - ' + objetoAparato.des  + ' - ' + increl ['(descodtipinc)'];
          if ((increl.infvar != '') && (increl.infvar != increl ['(descodtipinc)']))
            this.observaciones += ' (' + increl.infvar + ')';
          if (increl.tie)
            this.textoTiempoImporte += increl['(tie)'];
          if (increl.imp)
            this.textoTiempoImporte += ' / ' + this.$utilI18N.cadenaImporte (increl ['(imp)']);
          this.textoTiempoImporte = this.textoTiempoImporte.trim();
        }
      }

      this.$refs ['formularioAperturaManual'].resetValidation();
      this.visible = true;
      return new Promise ((resolve, reject) => {
        this.promesaResolve = resolve;
        this.promesaReject = reject;
      });
    },
    aceptarDialogo() {
      this.botonAceptarClicado = true;
      this.visible = false;
    },
    cancelarDialogo() {
      this.visible = false;
    },
    keypressCampoObservaciones() {
      if (!this.motivo)
        this.motivo = CONSTANTES_SAGA.MAM_OTRO;
    }
  },
  created() {
    this.listaMotivos = [
      { value: CONSTANTES_SAGA.MAM_ERROR_PRESENCIA, text: this.$t ('Error de presencia') },
      { value: CONSTANTES_SAGA.MAM_EXCESO_TIEMPO, text: this.$t ('Exceso de tiempo') },
      { value: CONSTANTES_SAGA.MAM_MAXIMO_PLAZAS_ALCANZADO, text: this.$t ('Máximo de plazas alcanzado') },
      { value: CONSTANTES_SAGA.MAM_ERROR_HORARIO, text: this.$t ('Entrada fuera del horario') },
      { value: CONSTANTES_SAGA.MAM_PRODUCTO_OLVIDADO, text: this.$t ('Producto olvidado') },
      { value: CONSTANTES_SAGA.MAM_PRODUCTO_CADUCADO, text: this.$t ('Producto caducado') },
      { value: CONSTANTES_SAGA.MAM_VEHICULO_NO_AUTORIZADO, text: this.$t ('Vehículo no autorizado') },
      { value: CONSTANTES_SAGA.MAM_PERDIDA_PRODUCTO, text: this.$t ('Pérdida del producto') },
      { value: CONSTANTES_SAGA.MAM_PRODUCTO_ILEGIBLE, text: this.$t ('Producto ilegible') },
      { value: CONSTANTES_SAGA.MAM_OTRO, text: this.$t ('(Otro)') },
    ];
  }
}
</script>

<style>

</style>